import React from 'react';
import { compose, lifecycle, withHandlers } from 'recompose';
import * as PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from  'react-router-dom';
import { connect } from 'react-redux';

import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import CardStatus from '../CardStatus';
import { commonStyles } from '../../styles/styles';

import darkOverlay from '../../assets/darkOverlay.svg'

import {selectedProgram, selectedProject} from '../../redux/selectors'

import {
 resetUserPrograms,
  selectRollout,
 selectUserPrograms
} from '../../redux/reducers/userProgramsFull';

import {
  MDBCard,
  MDBCardTitle,
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBAnimation
} from "mdbreact";
import { STORAGE_LINK } from '../../constants';


const RolloutCardReturn = ({ classes, rolloutCode, isSelected, status, name, description, startDate, dueDate, match, getProgram, returnFromProgramCard}) => (
  <div>
    {console.log('ROLLOUT MOUNTED RENDER', getProgram)}
    {getProgram && <MDBCard
  className="card-image border border-white rounded-0 z-depth-3 d-none d-md-block"
  style={{
    padding:8,
    margin: '0 0px 5px'
  }}
>

  <div style={{position: 'relative', backgroundColor: '#13A2E0', borderRadius: 8}}>
    <MDBBtn
        floating
        left
        tag='a'
        size='sm'
        className='ml-auto ml-4 '
        action
        style={{position: 'absolute', left: -30, top:30}} 
        onClick={()=>returnFromProgramCard()}
      >
        <MDBIcon icon='angle-left' className="secondary-color" size="sm"/>
    </MDBBtn>
    <div class="moduleImg2" style={{position:'unset'}}>
      <img src={STORAGE_LINK+getProgram.background} className="z-depth-0 " />
    </div>
    
    <div className="moduleCopy text-white" style={{marginBottom:0, paddingBottom:20, marginTop: '70%'}}>
      <div style={{fontSize: 12}}>
          {getProgram.rolloutCode}
      </div>
      <h6>
        {getProgram.name}
      </h6>
      <div className="copy">
        {getProgram.description}
      </div>
    </div>

</div> </MDBCard> }

</div>
);

const styles = () => ({
  ...commonStyles,
  card: {
    borderRadius: 0,
    backgroundSize: 'cover',
    marginLeft: 0,
    marginBottom: 0,
    marginRight: 0,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 15,
    paddingBottom: 15,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflow: 'visible',
    cursor: 'pointer',
    background: 'transparent',
    justifyContent: 'space-between',
    transition: '.2s height ease',
    fontFamily: 'Gotham-Black'
  },
  cardContent: {
    padding: 0,
    margin: 'auto',
    overflow: 'auto',
  },
  cardTitle: {
    color: '#FFF',
    fontSize: 18,
    lineHeight: '20px',
    marginTop: 19,
    marginBottom: 10,
    fontFamily: 'Gotham-Black'
  },
  programDescription: {
    color: '#FFF',
    fontSize: 14,
    lineHeight: '16px',
    fontWeight: 400,
    marginTop: 10,
    marginBottom: 17,
  },
});

const mapStateToProps = state => ({
  getProgram: selectedProject(state),
});

const mapDispatchToProps = dispatch => ({
  selectUserPrograms:(int) => dispatch(selectUserPrograms(int)),
  selectRollout:(int) => dispatch(selectRollout(int)),
  resetUserPrograms: () => dispatch(resetUserPrograms()),
 
});

export default compose(withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withHandlers({
    returnFromProgramCard: props => ()=>{
     if(props.match.path=='/rollouts/:projectId'){
      props.resetUserPrograms();
      props.history.push('/team-leader'+ props.history.location.search)
     }
     if(props.match.path=='/users/:projectId/:rolloutId'){
      props.resetUserPrograms();
      props.history.push('/rollouts/'+props.match.params.projectId+ props.history.location.search)
     }
    }
  }),
  lifecycle({
    componentWillMount(){
      console.log('CALL ME 2', this.props.match.params)
      if(this.props.match.params.projectId){
        this.props.selectUserPrograms(parseInt(this.props.match.params.projectId))
      }
      if(this.props.match.params.rolloutId){
        this.props.selectRollout(parseInt(this.props.match.params.rolloutId))
      }
      
    }
  }),
  withStyles(styles))(RolloutCardReturn);

  RolloutCardReturn.propTypes = {
  classes: PropTypes.instanceOf(Object),
  isSelected: PropTypes.bool,
  status: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  startDate: PropTypes.string,
  dueDate: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/Components/Cards/RolloutCardReturn.jsx